export default function(context) {
  //context.$store.dispatch("DelegationOrder/editDelegationOrder", context.contextItemId);
  context.$router.push("/delegation-order/readonly/" + context.contextItemId);
}
